// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: reader/reader_api.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import {
  AssertTransitionStates,
  assertTransitionStatesFromJSON,
  assertTransitionStatesToJSON,
} from "../assertions/assertion_types";
import { PaginationResponse } from "../common/grpc";
import {
  AssertHistoryRecordRequest,
  AssertHistoryRecordResponse,
  PortCounterHistoryRecordRequest,
  PortCounterHistoryRecordResponse,
  PortStateHistoryRecordRequest,
  PortStateHistoryRecordResponse,
} from "../druid/record_query_api";
import { Granularity, granularityFromJSON, granularityToJSON } from "../druid/timeseries_api_common";
import { Timestamp } from "../google/protobuf/timestamp";
import { AssertCategoryType, assertCategoryTypeFromJSON, assertCategoryTypeToJSON } from "../models/assert";
import { MetricType, metricTypeFromJSON, metricTypeToJSON } from "../models/dashboard";
import { NodeType, nodeTypeFromJSON, nodeTypeToJSON } from "../models/fabric";
import {
  ObjectType,
  objectTypeFromJSON,
  objectTypeToJSON,
  Operation,
  operationFromJSON,
  operationToJSON,
} from "../models/global";
import { AssertHistoryApiRecord } from "./assert_record_api";

export const protobufPackage = "reader";

/**
 * PROPRIETARY AND CONFIDENTIAL. Cisco Systems, Inc. considers the contents of this
 * file to be highly confidential trade secret information.
 *
 * COPYRIGHT 2023-present Cisco Systems, Inc., All rights reserved.
 */

/** ReaderType indicates the telemetry reader type */
export enum QueryType {
  /** UNSPECIFIED - Type unspecified */
  UNSPECIFIED = 0,
  /** PORT_STATE - high-level query types */
  PORT_STATE = 1,
  PORT_COUNTER_BIT_RATE = 2,
  PORT_COUNTER_PFC_COUNTER = 3,
  ASSERT_COUNTER_REPORT = 4,
  /** HISTORY_RECORD_QUERY_BASE - low-level query types */
  HISTORY_RECORD_QUERY_BASE = 100,
  PORT_STATE_HISTORY_RECORD = 101,
  PORT_COUNTER_HISTORY_RECORD = 102,
  ASSERT_HISTORY_RECORD = 103,
  UNRECOGNIZED = -1,
}

export function queryTypeFromJSON(object: any): QueryType {
  switch (object) {
    case 0:
    case "UNSPECIFIED":
      return QueryType.UNSPECIFIED;
    case 1:
    case "PORT_STATE":
      return QueryType.PORT_STATE;
    case 2:
    case "PORT_COUNTER_BIT_RATE":
      return QueryType.PORT_COUNTER_BIT_RATE;
    case 3:
    case "PORT_COUNTER_PFC_COUNTER":
      return QueryType.PORT_COUNTER_PFC_COUNTER;
    case 4:
    case "ASSERT_COUNTER_REPORT":
      return QueryType.ASSERT_COUNTER_REPORT;
    case 100:
    case "HISTORY_RECORD_QUERY_BASE":
      return QueryType.HISTORY_RECORD_QUERY_BASE;
    case 101:
    case "PORT_STATE_HISTORY_RECORD":
      return QueryType.PORT_STATE_HISTORY_RECORD;
    case 102:
    case "PORT_COUNTER_HISTORY_RECORD":
      return QueryType.PORT_COUNTER_HISTORY_RECORD;
    case 103:
    case "ASSERT_HISTORY_RECORD":
      return QueryType.ASSERT_HISTORY_RECORD;
    case -1:
    case "UNRECOGNIZED":
    default:
      return QueryType.UNRECOGNIZED;
  }
}

export function queryTypeToJSON(object: QueryType): string {
  switch (object) {
    case QueryType.UNSPECIFIED:
      return "UNSPECIFIED";
    case QueryType.PORT_STATE:
      return "PORT_STATE";
    case QueryType.PORT_COUNTER_BIT_RATE:
      return "PORT_COUNTER_BIT_RATE";
    case QueryType.PORT_COUNTER_PFC_COUNTER:
      return "PORT_COUNTER_PFC_COUNTER";
    case QueryType.ASSERT_COUNTER_REPORT:
      return "ASSERT_COUNTER_REPORT";
    case QueryType.HISTORY_RECORD_QUERY_BASE:
      return "HISTORY_RECORD_QUERY_BASE";
    case QueryType.PORT_STATE_HISTORY_RECORD:
      return "PORT_STATE_HISTORY_RECORD";
    case QueryType.PORT_COUNTER_HISTORY_RECORD:
      return "PORT_COUNTER_HISTORY_RECORD";
    case QueryType.ASSERT_HISTORY_RECORD:
      return "ASSERT_HISTORY_RECORD";
    case QueryType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum TrafficDirection {
  TX_AND_RX = 0,
  TX_ONLY = 1,
  RX_ONLY = 2,
  UNRECOGNIZED = -1,
}

export function trafficDirectionFromJSON(object: any): TrafficDirection {
  switch (object) {
    case 0:
    case "TX_AND_RX":
      return TrafficDirection.TX_AND_RX;
    case 1:
    case "TX_ONLY":
      return TrafficDirection.TX_ONLY;
    case 2:
    case "RX_ONLY":
      return TrafficDirection.RX_ONLY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TrafficDirection.UNRECOGNIZED;
  }
}

export function trafficDirectionToJSON(object: TrafficDirection): string {
  switch (object) {
    case TrafficDirection.TX_AND_RX:
      return "TX_AND_RX";
    case TrafficDirection.TX_ONLY:
      return "TX_ONLY";
    case TrafficDirection.RX_ONLY:
      return "RX_ONLY";
    case TrafficDirection.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum AssertCounterType {
  /** COUNTER_UNSPECIFIED - Type unspecified */
  COUNTER_UNSPECIFIED = 0,
  NEW_ONLY = 1,
  CLEARED_ONLY = 2,
  CONFIG_ACTIVITY = 3,
  SW_CONFIG_ACTIVITY = 4,
  UNRECOGNIZED = -1,
}

export function assertCounterTypeFromJSON(object: any): AssertCounterType {
  switch (object) {
    case 0:
    case "COUNTER_UNSPECIFIED":
      return AssertCounterType.COUNTER_UNSPECIFIED;
    case 1:
    case "NEW_ONLY":
      return AssertCounterType.NEW_ONLY;
    case 2:
    case "CLEARED_ONLY":
      return AssertCounterType.CLEARED_ONLY;
    case 3:
    case "CONFIG_ACTIVITY":
      return AssertCounterType.CONFIG_ACTIVITY;
    case 4:
    case "SW_CONFIG_ACTIVITY":
      return AssertCounterType.SW_CONFIG_ACTIVITY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AssertCounterType.UNRECOGNIZED;
  }
}

export function assertCounterTypeToJSON(object: AssertCounterType): string {
  switch (object) {
    case AssertCounterType.COUNTER_UNSPECIFIED:
      return "COUNTER_UNSPECIFIED";
    case AssertCounterType.NEW_ONLY:
      return "NEW_ONLY";
    case AssertCounterType.CLEARED_ONLY:
      return "CLEARED_ONLY";
    case AssertCounterType.CONFIG_ACTIVITY:
      return "CONFIG_ACTIVITY";
    case AssertCounterType.SW_CONFIG_ACTIVITY:
      return "SW_CONFIG_ACTIVITY";
    case AssertCounterType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum PortCounterValueType {
  /** PORT_COUNTER_VALUE_TYPE_UNSPECIFIED - Default to absolute counters for Metrics API/UI requests. */
  PORT_COUNTER_VALUE_TYPE_UNSPECIFIED = 0,
  PORT_COUNTER_VALUE_TYPE_ABSOLUTE = 1,
  PORT_COUNTER_VALUE_TYPE_DELTA = 2,
  UNRECOGNIZED = -1,
}

export function portCounterValueTypeFromJSON(object: any): PortCounterValueType {
  switch (object) {
    case 0:
    case "PORT_COUNTER_VALUE_TYPE_UNSPECIFIED":
      return PortCounterValueType.PORT_COUNTER_VALUE_TYPE_UNSPECIFIED;
    case 1:
    case "PORT_COUNTER_VALUE_TYPE_ABSOLUTE":
      return PortCounterValueType.PORT_COUNTER_VALUE_TYPE_ABSOLUTE;
    case 2:
    case "PORT_COUNTER_VALUE_TYPE_DELTA":
      return PortCounterValueType.PORT_COUNTER_VALUE_TYPE_DELTA;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PortCounterValueType.UNRECOGNIZED;
  }
}

export function portCounterValueTypeToJSON(object: PortCounterValueType): string {
  switch (object) {
    case PortCounterValueType.PORT_COUNTER_VALUE_TYPE_UNSPECIFIED:
      return "PORT_COUNTER_VALUE_TYPE_UNSPECIFIED";
    case PortCounterValueType.PORT_COUNTER_VALUE_TYPE_ABSOLUTE:
      return "PORT_COUNTER_VALUE_TYPE_ABSOLUTE";
    case PortCounterValueType.PORT_COUNTER_VALUE_TYPE_DELTA:
      return "PORT_COUNTER_VALUE_TYPE_DELTA";
    case PortCounterValueType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** AssertionHistorySelectField is the allow-list of columns the caller may project. AHQ_SELECT_TIME is always projected. */
export enum AssertionHistorySelectField {
  AHQ_SELECT_UNSPECIFIED = 0,
  AHQ_SELECT_TIME = 1,
  AHQ_SELECT_ASSERT_TYPE = 2,
  AHQ_SELECT_ASSERT_STATE = 3,
  AHQ_SELECT_OPERATION = 4,
  AHQ_SELECT_DEVICE = 5,
  AHQ_SELECT_PORT_NAME = 6,
  AHQ_SELECT_PORT_ID = 7,
  AHQ_SELECT_NODE_ID = 8,
  AHQ_SELECT_REMOTE_NODE_ID = 9,
  AHQ_SELECT_REMOTE_DEVICE = 10,
  AHQ_SELECT_FABRIC = 11,
  AHQ_SELECT_USERNAME = 12,
  AHQ_SELECT_TXN_ID = 13,
  AHQ_SELECT_CATEGORY = 14,
  AHQ_SELECT_OBJECT_TYPE = 15,
  AHQ_SELECT_OBJECT_ID = 16,
  AHQ_SELECT_OBJECT_NAME = 17,
  UNRECOGNIZED = -1,
}

export function assertionHistorySelectFieldFromJSON(object: any): AssertionHistorySelectField {
  switch (object) {
    case 0:
    case "AHQ_SELECT_UNSPECIFIED":
      return AssertionHistorySelectField.AHQ_SELECT_UNSPECIFIED;
    case 1:
    case "AHQ_SELECT_TIME":
      return AssertionHistorySelectField.AHQ_SELECT_TIME;
    case 2:
    case "AHQ_SELECT_ASSERT_TYPE":
      return AssertionHistorySelectField.AHQ_SELECT_ASSERT_TYPE;
    case 3:
    case "AHQ_SELECT_ASSERT_STATE":
      return AssertionHistorySelectField.AHQ_SELECT_ASSERT_STATE;
    case 4:
    case "AHQ_SELECT_OPERATION":
      return AssertionHistorySelectField.AHQ_SELECT_OPERATION;
    case 5:
    case "AHQ_SELECT_DEVICE":
      return AssertionHistorySelectField.AHQ_SELECT_DEVICE;
    case 6:
    case "AHQ_SELECT_PORT_NAME":
      return AssertionHistorySelectField.AHQ_SELECT_PORT_NAME;
    case 7:
    case "AHQ_SELECT_PORT_ID":
      return AssertionHistorySelectField.AHQ_SELECT_PORT_ID;
    case 8:
    case "AHQ_SELECT_NODE_ID":
      return AssertionHistorySelectField.AHQ_SELECT_NODE_ID;
    case 9:
    case "AHQ_SELECT_REMOTE_NODE_ID":
      return AssertionHistorySelectField.AHQ_SELECT_REMOTE_NODE_ID;
    case 10:
    case "AHQ_SELECT_REMOTE_DEVICE":
      return AssertionHistorySelectField.AHQ_SELECT_REMOTE_DEVICE;
    case 11:
    case "AHQ_SELECT_FABRIC":
      return AssertionHistorySelectField.AHQ_SELECT_FABRIC;
    case 12:
    case "AHQ_SELECT_USERNAME":
      return AssertionHistorySelectField.AHQ_SELECT_USERNAME;
    case 13:
    case "AHQ_SELECT_TXN_ID":
      return AssertionHistorySelectField.AHQ_SELECT_TXN_ID;
    case 14:
    case "AHQ_SELECT_CATEGORY":
      return AssertionHistorySelectField.AHQ_SELECT_CATEGORY;
    case 15:
    case "AHQ_SELECT_OBJECT_TYPE":
      return AssertionHistorySelectField.AHQ_SELECT_OBJECT_TYPE;
    case 16:
    case "AHQ_SELECT_OBJECT_ID":
      return AssertionHistorySelectField.AHQ_SELECT_OBJECT_ID;
    case 17:
    case "AHQ_SELECT_OBJECT_NAME":
      return AssertionHistorySelectField.AHQ_SELECT_OBJECT_NAME;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AssertionHistorySelectField.UNRECOGNIZED;
  }
}

export function assertionHistorySelectFieldToJSON(object: AssertionHistorySelectField): string {
  switch (object) {
    case AssertionHistorySelectField.AHQ_SELECT_UNSPECIFIED:
      return "AHQ_SELECT_UNSPECIFIED";
    case AssertionHistorySelectField.AHQ_SELECT_TIME:
      return "AHQ_SELECT_TIME";
    case AssertionHistorySelectField.AHQ_SELECT_ASSERT_TYPE:
      return "AHQ_SELECT_ASSERT_TYPE";
    case AssertionHistorySelectField.AHQ_SELECT_ASSERT_STATE:
      return "AHQ_SELECT_ASSERT_STATE";
    case AssertionHistorySelectField.AHQ_SELECT_OPERATION:
      return "AHQ_SELECT_OPERATION";
    case AssertionHistorySelectField.AHQ_SELECT_DEVICE:
      return "AHQ_SELECT_DEVICE";
    case AssertionHistorySelectField.AHQ_SELECT_PORT_NAME:
      return "AHQ_SELECT_PORT_NAME";
    case AssertionHistorySelectField.AHQ_SELECT_PORT_ID:
      return "AHQ_SELECT_PORT_ID";
    case AssertionHistorySelectField.AHQ_SELECT_NODE_ID:
      return "AHQ_SELECT_NODE_ID";
    case AssertionHistorySelectField.AHQ_SELECT_REMOTE_NODE_ID:
      return "AHQ_SELECT_REMOTE_NODE_ID";
    case AssertionHistorySelectField.AHQ_SELECT_REMOTE_DEVICE:
      return "AHQ_SELECT_REMOTE_DEVICE";
    case AssertionHistorySelectField.AHQ_SELECT_FABRIC:
      return "AHQ_SELECT_FABRIC";
    case AssertionHistorySelectField.AHQ_SELECT_USERNAME:
      return "AHQ_SELECT_USERNAME";
    case AssertionHistorySelectField.AHQ_SELECT_TXN_ID:
      return "AHQ_SELECT_TXN_ID";
    case AssertionHistorySelectField.AHQ_SELECT_CATEGORY:
      return "AHQ_SELECT_CATEGORY";
    case AssertionHistorySelectField.AHQ_SELECT_OBJECT_TYPE:
      return "AHQ_SELECT_OBJECT_TYPE";
    case AssertionHistorySelectField.AHQ_SELECT_OBJECT_ID:
      return "AHQ_SELECT_OBJECT_ID";
    case AssertionHistorySelectField.AHQ_SELECT_OBJECT_NAME:
      return "AHQ_SELECT_OBJECT_NAME";
    case AssertionHistorySelectField.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** HistoryRequest is the top-level request object that encapsulates specific query parameters. */
export interface HistoryRequest {
  /** Indicates the type of data point */
  type: QueryType;
  /** Time at which the port stats were collected by agent. */
  startTime:
    | Date
    | undefined;
  /** Time at which the port stats were collected by agent. */
  endTime:
    | Date
    | undefined;
  /** Query granularity interval. Mutually exclusive with num_buckets. */
  granularity: Granularity;
  /**
   * The maximum number of results to return in a single response. If not specified, the API will return
   * a fixed number of results for the request.  The API will not interpret the context of this limit (e.g., topN query).
   * For timeseries queries, the server will add a fudge factor to the requested limit so expect additional results back in the client.
   */
  limit: number;
  /**
   * Number of buckets. Mutually exclusive with granularity.
   * If supplied, time will be bucketized down to the closest minute resolution.
   * Note that the result might be a bit strange if the computed interval doesn't evenly divide into the requested window.
   */
  numBuckets: number;
  /** Do not include a fudge factor when calculating the number of records to return. */
  noFudgeFactor: boolean;
  /** Traffic direction for the bit rate metric type */
  direction: TrafficDirection;
  /** Filter by the fabric UUID or name */
  fabric: string;
  /** Filter by device MAC address or name */
  device: string;
  /** Unique identifier of a port within a device */
  portId: string;
  /** Filter by one or more assertion types. */
  assertType: string[];
  /** If set, response will be encoded in druid native proto */
  druidNative: boolean;
  counterType: AssertCounterType[];
  /** Filter by node_id */
  nodeId: string;
  /** port name at the corresponding port_id */
  portName: string;
  /** Filter by remote device id or mac address */
  remoteDevice: string;
  /** Filter by remote node id */
  remoteNodeId: string;
  /**
   * Optional: Multi-device/port filters for querying multiple devices and ports in one request
   * If provided, this field takes precedence over single device/port_id fields above
   * Enables efficient bulk queries with parallel execution and aggregated results
   */
  filters: DeviceMetricsFilter[];
  /**
   * Optional: Specific metrics to retrieve (camelCase field names from PortCounters)
   * If not provided, all available metrics for the query type will be returned
   * Dashboard users can specify metrics using familiar field names: "inOctets", "outPkts", "inPfc7Pkts", etc.
   * Backend converts these to internal enum values (PCP_IN_OCTETS_TOTAL, PCP_OUT_PKTS_TOTAL, etc.)
   * Both aggregator metrics and rate metrics support time granularity with GROUP BY queries
   */
  metrics: MetricType[];
  /**
   * Optional: Include empty data points with zero values (default: false)
   * When true, missing time buckets within the query range are filled with zeros for consistent chart rendering
   * When false, only buckets with actual data are returned (sparse response)
   */
  includeEmptyPoints: boolean;
  /** Filter by one or more assertion categories. Only PORT, DEVICE, and NETWORK are accepted. */
  category: AssertCategoryType[];
  /** Filter by one or more config object types. */
  objectTypes: ObjectType[];
  /**
   * Select absolute or delta counter datasource for port counter metric queries.
   * If unspecified, the Metrics API defaults to absolute counters.
   */
  portCounterValueType: PortCounterValueType;
  /** Filter by one or more operations. */
  operation: Operation[];
  /** low-level query requests */
  portStateReq: PortStateHistoryRecordRequest | undefined;
  portCounterReq: PortCounterHistoryRecordRequest | undefined;
  assertRecordReq: AssertHistoryRecordRequest | undefined;
}

/** AssertRestCounterReportRequest is the top-level query request to collect the assertion counters */
export interface AssertRestCounterReportRequest {
  /** The start time in datetime string format */
  startTime: string;
  /** The end time in datetime string format */
  endTime: string;
  /** The query granularity in time interval */
  granularity: Granularity;
  /** The maximum number (default to 500) of results to return in a single response. */
  limit: number;
  /** Filter by the fabric UUID or name */
  fabric: string;
  /** Filter by the device MAC address or name */
  device: string;
  /** Filter by the port id or name */
  port: string;
  /** Filter by one or more assertion types. */
  assertType: string[];
  /** Filter by one or more counter_type */
  counterType: AssertCounterType[];
  /** Filter by one or more assertion categories. Only PORT, DEVICE, and NETWORK are accepted. */
  category: AssertCategoryType[];
  /** Filter by one or more object types. */
  objectTypes: ObjectType[];
  /** Filter by one or more operations. */
  operation: Operation[];
}

/** AssertCounterReport holds an assertion counter record at particular time instance */
export interface AssertCounterReport {
  /** the device name or UUID */
  device: string;
  /** The port index. */
  portName: string;
  /** The assert type */
  type: string;
  /** The number of new false asserts per time granularity */
  newFalseAsserts: number;
  /** The number of cleared false asserts per time granularity */
  clearedFalseAsserts: number;
  /** The number of config activities during the time granularity */
  configActivities: number;
  /** The timestamp associated this report */
  timestamp:
    | Date
    | undefined;
  /** The assertion category */
  category: string;
  /** The number of software config activities during the time granularity */
  swConfigActivities: number;
}

/** AssertCounterReportResponse holds the AssertCounter time series query result. */
export interface AssertCounterReportResponse {
  counterReport: AssertCounterReport[];
  pagination: PaginationResponse | undefined;
}

/** AssertRestRecordRequest is the top-level query request to collect the assertion records */
export interface AssertRestRecordRequest {
  /** The start time in datetime string format */
  startTime: string;
  /** The end time in datetime string format */
  endTime: string;
  /** The query granularity in time interval */
  granularity: Granularity;
  /** The maximum number (default to 500) of results to return in a single response. */
  limit: number;
  /** Filter by the fabric id */
  fabric: string;
  /** Filter by the device id */
  device: string;
  /** Filter by the port id or name */
  port: string;
  /** Filter by one or more assertion types. */
  assertType: string[];
  /** Filter by one or more counter_type */
  counterType: AssertCounterType[];
  /** Filter by one or more assertion categories. Only PORT, DEVICE, and NETWORK are accepted. */
  category: AssertCategoryType[];
  /** Filter by one or more object types. */
  objectTypes: ObjectType[];
}

/** AssertHistoryRecordResponseSchemaProto holds the Assertion record time series query result in the message format defined in schema.proto. */
export interface AssertHistoryApiRecordResponse {
  assertions: AssertHistoryApiRecord[];
  /** The common pagination properties in the response message */
  pagination: PaginationResponse | undefined;
}

/** HistoryResponse is the top-level history query response message for all supported query types */
export interface HistoryResponse {
  queryType: QueryType;
  portStateResponse: PortStateHistoryRecordResponse | undefined;
  portCounterResponse: PortCounterHistoryRecordResponse | undefined;
  assertCounterReport: AssertCounterReportResponse | undefined;
  assertResponse: AssertHistoryRecordResponse | undefined;
  assertApiResponse:
    | AssertHistoryApiRecordResponse
    | undefined;
  /** Metrics data response (when filters field is used in request) */
  data: MetricsData | undefined;
}

/** MetricsData contains aggregated metrics from multiple devices/ports */
export interface MetricsData {
  /** Timeseries data grouped by device, port, or component */
  timeseries: MetricsTimeseries[];
  /** Total number of data points returned */
  totalCount: number;
}

/** DeviceMetricsFilter specifies which device and optionally which ports to query */
export interface DeviceMetricsFilter {
  /** Device ID (MAC address) or device name */
  device: string;
  /**
   * Device type (switch or server)
   * Helps identify the correct data source and available metrics
   */
  deviceType: NodeType;
  /** Port names to query for this device (e.g., "Ethernet1/1", "Ethernet22/2") */
  portNames: string[];
}

/** MetricsTimeseries contains timeseries data for a specific device/port */
export interface MetricsTimeseries {
  /** Device ID (MAC address), e.g., "50-49-21-0a-37-20" */
  deviceId: string;
  /** Port name (e.g., "Ethernet22/2", empty for device-level metrics) */
  portName: string;
  /** Timeseries data points */
  dataPoints: MetricDataPoint[];
}

/** MetricDataPoint represents a single timeseries data point */
export interface MetricDataPoint {
  /** Timestamp for this data point */
  timestamp:
    | Date
    | undefined;
  /** Metric values at this timestamp */
  metrics: number[];
}

/** StringInList is a non-empty IN-list of free-form string values. */
export interface StringInList {
  values: string[];
}

/** AssertTypeInList carries assert_type values validated against assertions.AssertType_value. */
export interface AssertTypeInList {
  values: string[];
}

/** AssertStateInList carries typed assert_state values. */
export interface AssertStateInList {
  values: AssertTransitionStates[];
}

/** CategoryInList carries typed category values (allow-list: PORT, DEVICE, NETWORK). */
export interface CategoryInList {
  values: AssertCategoryType[];
}

/** OperationInList carries typed operation values (e.g. COMMIT, REVERT). */
export interface OperationInList {
  values: Operation[];
}

/** ObjectTypeInList carries typed object_type values (e.g. NODE_IMAGE_UPDATE, FABRIC_IMAGE_UPDATE). */
export interface ObjectTypeInList {
  values: ObjectType[];
}

/** AssertionHistoryFilterPredicate is a single typed IN-style predicate. Exactly one oneof variant must be set. */
export interface AssertionHistoryFilterPredicate {
  deviceIn?: StringInList | undefined;
  portNameIn?: StringInList | undefined;
  portIdIn?: StringInList | undefined;
  nodeIdIn?: StringInList | undefined;
  remoteNodeIdIn?: StringInList | undefined;
  remoteDeviceIn?: StringInList | undefined;
  usernameIn?: StringInList | undefined;
  txnIdIn?: StringInList | undefined;
  objectIdIn?: StringInList | undefined;
  objectNameIn?: StringInList | undefined;
  assertTypeIn?: AssertTypeInList | undefined;
  assertStateIn?: AssertStateInList | undefined;
  categoryIn?: CategoryInList | undefined;
  operationIn?: OperationInList | undefined;
  objectTypeIn?: ObjectTypeInList | undefined;
}

/** AssertionHistoryFilterBranch is a conjunction (AND) of typed predicates. At least one predicate is required. */
export interface AssertionHistoryFilterBranch {
  predicates: AssertionHistoryFilterPredicate[];
}

/** AssertionHistoryQueryRequest is the top-level typed UI request for assertion-history queries. */
export interface AssertionHistoryQueryRequest {
  /** Required inclusive lower bound of the query time window. */
  startTime:
    | Date
    | undefined;
  /** Required exclusive upper bound of the query time window. */
  endTime:
    | Date
    | undefined;
  /** Required: at least one fabric UUID or name. Rendered as fabric IN (...). */
  fabrics: string[];
  /** Required: at least one filter branch (branches are OR-ed). */
  branches: AssertionHistoryFilterBranch[];
  /** Required: at least one return field. AHQ_SELECT_TIME is implicitly added. */
  selectFields: AssertionHistorySelectField[];
  /** Optional server-capped row cap. */
  limit: number;
  /** Optional query granularity for time bucketing. */
  granularity: Granularity;
}

/** AssertionHistoryQueryRow holds the selected fields; unselected fields retain their zero value. */
export interface AssertionHistoryQueryRow {
  time: Date | undefined;
  assertType: string;
  assertState: AssertTransitionStates;
  operation: Operation;
  device: string;
  portName: string;
  portId: string;
  nodeId: string;
  remoteNodeId: string;
  remoteDevice: string;
  fabric: string;
  username: string;
  txnId: string;
  category: AssertCategoryType;
  objectType: ObjectType;
  objectId: string;
  objectName: string;
}

/** AssertionHistoryQueryResponse is the typed result envelope. */
export interface AssertionHistoryQueryResponse {
  rows: AssertionHistoryQueryRow[];
  /** pagination.final = false means the row set hit the server-side limit. */
  pagination: PaginationResponse | undefined;
}

function createBaseHistoryRequest(): HistoryRequest {
  return {
    type: 0,
    startTime: undefined,
    endTime: undefined,
    granularity: 0,
    limit: 0,
    numBuckets: 0,
    noFudgeFactor: false,
    direction: 0,
    fabric: "",
    device: "",
    portId: "",
    assertType: [],
    druidNative: false,
    counterType: [],
    nodeId: "",
    portName: "",
    remoteDevice: "",
    remoteNodeId: "",
    filters: [],
    metrics: [],
    includeEmptyPoints: false,
    category: [],
    objectTypes: [],
    portCounterValueType: 0,
    operation: [],
    portStateReq: undefined,
    portCounterReq: undefined,
    assertRecordReq: undefined,
  };
}

export const HistoryRequest: MessageFns<HistoryRequest> = {
  encode(message: HistoryRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.startTime !== undefined) {
      Timestamp.encode(toTimestamp(message.startTime), writer.uint32(18).fork()).join();
    }
    if (message.endTime !== undefined) {
      Timestamp.encode(toTimestamp(message.endTime), writer.uint32(26).fork()).join();
    }
    if (message.granularity !== 0) {
      writer.uint32(32).int32(message.granularity);
    }
    if (message.limit !== 0) {
      writer.uint32(40).uint32(message.limit);
    }
    if (message.numBuckets !== 0) {
      writer.uint32(48).uint32(message.numBuckets);
    }
    if (message.noFudgeFactor !== false) {
      writer.uint32(56).bool(message.noFudgeFactor);
    }
    if (message.direction !== 0) {
      writer.uint32(64).int32(message.direction);
    }
    if (message.fabric !== "") {
      writer.uint32(74).string(message.fabric);
    }
    if (message.device !== "") {
      writer.uint32(82).string(message.device);
    }
    if (message.portId !== "") {
      writer.uint32(90).string(message.portId);
    }
    for (const v of message.assertType) {
      writer.uint32(98).string(v!);
    }
    if (message.druidNative !== false) {
      writer.uint32(104).bool(message.druidNative);
    }
    writer.uint32(114).fork();
    for (const v of message.counterType) {
      writer.int32(v);
    }
    writer.join();
    if (message.nodeId !== "") {
      writer.uint32(122).string(message.nodeId);
    }
    if (message.portName !== "") {
      writer.uint32(130).string(message.portName);
    }
    if (message.remoteDevice !== "") {
      writer.uint32(138).string(message.remoteDevice);
    }
    if (message.remoteNodeId !== "") {
      writer.uint32(146).string(message.remoteNodeId);
    }
    for (const v of message.filters) {
      DeviceMetricsFilter.encode(v!, writer.uint32(154).fork()).join();
    }
    writer.uint32(162).fork();
    for (const v of message.metrics) {
      writer.int32(v);
    }
    writer.join();
    if (message.includeEmptyPoints !== false) {
      writer.uint32(168).bool(message.includeEmptyPoints);
    }
    writer.uint32(178).fork();
    for (const v of message.category) {
      writer.int32(v);
    }
    writer.join();
    writer.uint32(186).fork();
    for (const v of message.objectTypes) {
      writer.int32(v);
    }
    writer.join();
    if (message.portCounterValueType !== 0) {
      writer.uint32(192).int32(message.portCounterValueType);
    }
    writer.uint32(202).fork();
    for (const v of message.operation) {
      writer.int32(v);
    }
    writer.join();
    if (message.portStateReq !== undefined) {
      PortStateHistoryRecordRequest.encode(message.portStateReq, writer.uint32(810).fork()).join();
    }
    if (message.portCounterReq !== undefined) {
      PortCounterHistoryRecordRequest.encode(message.portCounterReq, writer.uint32(818).fork()).join();
    }
    if (message.assertRecordReq !== undefined) {
      AssertHistoryRecordRequest.encode(message.assertRecordReq, writer.uint32(826).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HistoryRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHistoryRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.startTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.endTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.granularity = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.limit = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.numBuckets = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.noFudgeFactor = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.direction = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.fabric = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.device = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.portId = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.assertType.push(reader.string());
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.druidNative = reader.bool();
          continue;
        }
        case 14: {
          if (tag === 112) {
            message.counterType.push(reader.int32() as any);

            continue;
          }

          if (tag === 114) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.counterType.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.portName = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.remoteDevice = reader.string();
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.remoteNodeId = reader.string();
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.filters.push(DeviceMetricsFilter.decode(reader, reader.uint32()));
          continue;
        }
        case 20: {
          if (tag === 160) {
            message.metrics.push(reader.int32() as any);

            continue;
          }

          if (tag === 162) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.metrics.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.includeEmptyPoints = reader.bool();
          continue;
        }
        case 22: {
          if (tag === 176) {
            message.category.push(reader.int32() as any);

            continue;
          }

          if (tag === 178) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.category.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 23: {
          if (tag === 184) {
            message.objectTypes.push(reader.int32() as any);

            continue;
          }

          if (tag === 186) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.objectTypes.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.portCounterValueType = reader.int32() as any;
          continue;
        }
        case 25: {
          if (tag === 200) {
            message.operation.push(reader.int32() as any);

            continue;
          }

          if (tag === 202) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.operation.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 101: {
          if (tag !== 810) {
            break;
          }

          message.portStateReq = PortStateHistoryRecordRequest.decode(reader, reader.uint32());
          continue;
        }
        case 102: {
          if (tag !== 818) {
            break;
          }

          message.portCounterReq = PortCounterHistoryRecordRequest.decode(reader, reader.uint32());
          continue;
        }
        case 103: {
          if (tag !== 826) {
            break;
          }

          message.assertRecordReq = AssertHistoryRecordRequest.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HistoryRequest {
    return {
      type: isSet(object.type) ? queryTypeFromJSON(object.type) : 0,
      startTime: isSet(object.startTime) ? fromJsonTimestamp(object.startTime) : undefined,
      endTime: isSet(object.endTime) ? fromJsonTimestamp(object.endTime) : undefined,
      granularity: isSet(object.granularity) ? granularityFromJSON(object.granularity) : 0,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : 0,
      numBuckets: isSet(object.numBuckets) ? globalThis.Number(object.numBuckets) : 0,
      noFudgeFactor: isSet(object.noFudgeFactor) ? globalThis.Boolean(object.noFudgeFactor) : false,
      direction: isSet(object.direction) ? trafficDirectionFromJSON(object.direction) : 0,
      fabric: isSet(object.fabric) ? globalThis.String(object.fabric) : "",
      device: isSet(object.device) ? globalThis.String(object.device) : "",
      portId: isSet(object.portId) ? globalThis.String(object.portId) : "",
      assertType: globalThis.Array.isArray(object?.assertType)
        ? object.assertType.map((e: any) => globalThis.String(e))
        : [],
      druidNative: isSet(object.druidNative) ? globalThis.Boolean(object.druidNative) : false,
      counterType: globalThis.Array.isArray(object?.counterType)
        ? object.counterType.map((e: any) => assertCounterTypeFromJSON(e))
        : [],
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      portName: isSet(object.portName) ? globalThis.String(object.portName) : "",
      remoteDevice: isSet(object.remoteDevice) ? globalThis.String(object.remoteDevice) : "",
      remoteNodeId: isSet(object.remoteNodeId) ? globalThis.String(object.remoteNodeId) : "",
      filters: globalThis.Array.isArray(object?.filters)
        ? object.filters.map((e: any) => DeviceMetricsFilter.fromJSON(e))
        : [],
      metrics: globalThis.Array.isArray(object?.metrics) ? object.metrics.map((e: any) => metricTypeFromJSON(e)) : [],
      includeEmptyPoints: isSet(object.includeEmptyPoints) ? globalThis.Boolean(object.includeEmptyPoints) : false,
      category: globalThis.Array.isArray(object?.category)
        ? object.category.map((e: any) => assertCategoryTypeFromJSON(e))
        : [],
      objectTypes: globalThis.Array.isArray(object?.objectTypes)
        ? object.objectTypes.map((e: any) => objectTypeFromJSON(e))
        : [],
      portCounterValueType: isSet(object.portCounterValueType)
        ? portCounterValueTypeFromJSON(object.portCounterValueType)
        : 0,
      operation: globalThis.Array.isArray(object?.operation)
        ? object.operation.map((e: any) => operationFromJSON(e))
        : [],
      portStateReq: isSet(object.portStateReq)
        ? PortStateHistoryRecordRequest.fromJSON(object.portStateReq)
        : undefined,
      portCounterReq: isSet(object.portCounterReq)
        ? PortCounterHistoryRecordRequest.fromJSON(object.portCounterReq)
        : undefined,
      assertRecordReq: isSet(object.assertRecordReq)
        ? AssertHistoryRecordRequest.fromJSON(object.assertRecordReq)
        : undefined,
    };
  },

  toJSON(message: HistoryRequest): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = queryTypeToJSON(message.type);
    }
    if (message.startTime !== undefined) {
      obj.startTime = message.startTime.toISOString();
    }
    if (message.endTime !== undefined) {
      obj.endTime = message.endTime.toISOString();
    }
    if (message.granularity !== 0) {
      obj.granularity = granularityToJSON(message.granularity);
    }
    if (message.limit !== 0) {
      obj.limit = Math.round(message.limit);
    }
    if (message.numBuckets !== 0) {
      obj.numBuckets = Math.round(message.numBuckets);
    }
    if (message.noFudgeFactor !== false) {
      obj.noFudgeFactor = message.noFudgeFactor;
    }
    if (message.direction !== 0) {
      obj.direction = trafficDirectionToJSON(message.direction);
    }
    if (message.fabric !== "") {
      obj.fabric = message.fabric;
    }
    if (message.device !== "") {
      obj.device = message.device;
    }
    if (message.portId !== "") {
      obj.portId = message.portId;
    }
    if (message.assertType?.length) {
      obj.assertType = message.assertType;
    }
    if (message.druidNative !== false) {
      obj.druidNative = message.druidNative;
    }
    if (message.counterType?.length) {
      obj.counterType = message.counterType.map((e) => assertCounterTypeToJSON(e));
    }
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.portName !== "") {
      obj.portName = message.portName;
    }
    if (message.remoteDevice !== "") {
      obj.remoteDevice = message.remoteDevice;
    }
    if (message.remoteNodeId !== "") {
      obj.remoteNodeId = message.remoteNodeId;
    }
    if (message.filters?.length) {
      obj.filters = message.filters.map((e) => DeviceMetricsFilter.toJSON(e));
    }
    if (message.metrics?.length) {
      obj.metrics = message.metrics.map((e) => metricTypeToJSON(e));
    }
    if (message.includeEmptyPoints !== false) {
      obj.includeEmptyPoints = message.includeEmptyPoints;
    }
    if (message.category?.length) {
      obj.category = message.category.map((e) => assertCategoryTypeToJSON(e));
    }
    if (message.objectTypes?.length) {
      obj.objectTypes = message.objectTypes.map((e) => objectTypeToJSON(e));
    }
    if (message.portCounterValueType !== 0) {
      obj.portCounterValueType = portCounterValueTypeToJSON(message.portCounterValueType);
    }
    if (message.operation?.length) {
      obj.operation = message.operation.map((e) => operationToJSON(e));
    }
    if (message.portStateReq !== undefined) {
      obj.portStateReq = PortStateHistoryRecordRequest.toJSON(message.portStateReq);
    }
    if (message.portCounterReq !== undefined) {
      obj.portCounterReq = PortCounterHistoryRecordRequest.toJSON(message.portCounterReq);
    }
    if (message.assertRecordReq !== undefined) {
      obj.assertRecordReq = AssertHistoryRecordRequest.toJSON(message.assertRecordReq);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HistoryRequest>, I>>(base?: I): HistoryRequest {
    return HistoryRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HistoryRequest>, I>>(object: I): HistoryRequest {
    const message = createBaseHistoryRequest();
    message.type = object.type ?? 0;
    message.startTime = object.startTime ?? undefined;
    message.endTime = object.endTime ?? undefined;
    message.granularity = object.granularity ?? 0;
    message.limit = object.limit ?? 0;
    message.numBuckets = object.numBuckets ?? 0;
    message.noFudgeFactor = object.noFudgeFactor ?? false;
    message.direction = object.direction ?? 0;
    message.fabric = object.fabric ?? "";
    message.device = object.device ?? "";
    message.portId = object.portId ?? "";
    message.assertType = object.assertType?.map((e) => e) || [];
    message.druidNative = object.druidNative ?? false;
    message.counterType = object.counterType?.map((e) => e) || [];
    message.nodeId = object.nodeId ?? "";
    message.portName = object.portName ?? "";
    message.remoteDevice = object.remoteDevice ?? "";
    message.remoteNodeId = object.remoteNodeId ?? "";
    message.filters = object.filters?.map((e) => DeviceMetricsFilter.fromPartial(e)) || [];
    message.metrics = object.metrics?.map((e) => e) || [];
    message.includeEmptyPoints = object.includeEmptyPoints ?? false;
    message.category = object.category?.map((e) => e) || [];
    message.objectTypes = object.objectTypes?.map((e) => e) || [];
    message.portCounterValueType = object.portCounterValueType ?? 0;
    message.operation = object.operation?.map((e) => e) || [];
    message.portStateReq = (object.portStateReq !== undefined && object.portStateReq !== null)
      ? PortStateHistoryRecordRequest.fromPartial(object.portStateReq)
      : undefined;
    message.portCounterReq = (object.portCounterReq !== undefined && object.portCounterReq !== null)
      ? PortCounterHistoryRecordRequest.fromPartial(object.portCounterReq)
      : undefined;
    message.assertRecordReq = (object.assertRecordReq !== undefined && object.assertRecordReq !== null)
      ? AssertHistoryRecordRequest.fromPartial(object.assertRecordReq)
      : undefined;
    return message;
  },
};

function createBaseAssertRestCounterReportRequest(): AssertRestCounterReportRequest {
  return {
    startTime: "",
    endTime: "",
    granularity: 0,
    limit: 0,
    fabric: "",
    device: "",
    port: "",
    assertType: [],
    counterType: [],
    category: [],
    objectTypes: [],
    operation: [],
  };
}

export const AssertRestCounterReportRequest: MessageFns<AssertRestCounterReportRequest> = {
  encode(message: AssertRestCounterReportRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.startTime !== "") {
      writer.uint32(18).string(message.startTime);
    }
    if (message.endTime !== "") {
      writer.uint32(26).string(message.endTime);
    }
    if (message.granularity !== 0) {
      writer.uint32(32).int32(message.granularity);
    }
    if (message.limit !== 0) {
      writer.uint32(40).uint32(message.limit);
    }
    if (message.fabric !== "") {
      writer.uint32(50).string(message.fabric);
    }
    if (message.device !== "") {
      writer.uint32(58).string(message.device);
    }
    if (message.port !== "") {
      writer.uint32(66).string(message.port);
    }
    for (const v of message.assertType) {
      writer.uint32(74).string(v!);
    }
    writer.uint32(82).fork();
    for (const v of message.counterType) {
      writer.int32(v);
    }
    writer.join();
    writer.uint32(90).fork();
    for (const v of message.category) {
      writer.int32(v);
    }
    writer.join();
    writer.uint32(98).fork();
    for (const v of message.objectTypes) {
      writer.int32(v);
    }
    writer.join();
    writer.uint32(106).fork();
    for (const v of message.operation) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertRestCounterReportRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertRestCounterReportRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.startTime = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.endTime = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.granularity = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.limit = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.fabric = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.device = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.port = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.assertType.push(reader.string());
          continue;
        }
        case 10: {
          if (tag === 80) {
            message.counterType.push(reader.int32() as any);

            continue;
          }

          if (tag === 82) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.counterType.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 11: {
          if (tag === 88) {
            message.category.push(reader.int32() as any);

            continue;
          }

          if (tag === 90) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.category.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 12: {
          if (tag === 96) {
            message.objectTypes.push(reader.int32() as any);

            continue;
          }

          if (tag === 98) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.objectTypes.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 13: {
          if (tag === 104) {
            message.operation.push(reader.int32() as any);

            continue;
          }

          if (tag === 106) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.operation.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertRestCounterReportRequest {
    return {
      startTime: isSet(object.startTime) ? globalThis.String(object.startTime) : "",
      endTime: isSet(object.endTime) ? globalThis.String(object.endTime) : "",
      granularity: isSet(object.granularity) ? granularityFromJSON(object.granularity) : 0,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : 0,
      fabric: isSet(object.fabric) ? globalThis.String(object.fabric) : "",
      device: isSet(object.device) ? globalThis.String(object.device) : "",
      port: isSet(object.port) ? globalThis.String(object.port) : "",
      assertType: globalThis.Array.isArray(object?.assertType)
        ? object.assertType.map((e: any) => globalThis.String(e))
        : [],
      counterType: globalThis.Array.isArray(object?.counterType)
        ? object.counterType.map((e: any) => assertCounterTypeFromJSON(e))
        : [],
      category: globalThis.Array.isArray(object?.category)
        ? object.category.map((e: any) => assertCategoryTypeFromJSON(e))
        : [],
      objectTypes: globalThis.Array.isArray(object?.objectTypes)
        ? object.objectTypes.map((e: any) => objectTypeFromJSON(e))
        : [],
      operation: globalThis.Array.isArray(object?.operation)
        ? object.operation.map((e: any) => operationFromJSON(e))
        : [],
    };
  },

  toJSON(message: AssertRestCounterReportRequest): unknown {
    const obj: any = {};
    if (message.startTime !== "") {
      obj.startTime = message.startTime;
    }
    if (message.endTime !== "") {
      obj.endTime = message.endTime;
    }
    if (message.granularity !== 0) {
      obj.granularity = granularityToJSON(message.granularity);
    }
    if (message.limit !== 0) {
      obj.limit = Math.round(message.limit);
    }
    if (message.fabric !== "") {
      obj.fabric = message.fabric;
    }
    if (message.device !== "") {
      obj.device = message.device;
    }
    if (message.port !== "") {
      obj.port = message.port;
    }
    if (message.assertType?.length) {
      obj.assertType = message.assertType;
    }
    if (message.counterType?.length) {
      obj.counterType = message.counterType.map((e) => assertCounterTypeToJSON(e));
    }
    if (message.category?.length) {
      obj.category = message.category.map((e) => assertCategoryTypeToJSON(e));
    }
    if (message.objectTypes?.length) {
      obj.objectTypes = message.objectTypes.map((e) => objectTypeToJSON(e));
    }
    if (message.operation?.length) {
      obj.operation = message.operation.map((e) => operationToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertRestCounterReportRequest>, I>>(base?: I): AssertRestCounterReportRequest {
    return AssertRestCounterReportRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertRestCounterReportRequest>, I>>(
    object: I,
  ): AssertRestCounterReportRequest {
    const message = createBaseAssertRestCounterReportRequest();
    message.startTime = object.startTime ?? "";
    message.endTime = object.endTime ?? "";
    message.granularity = object.granularity ?? 0;
    message.limit = object.limit ?? 0;
    message.fabric = object.fabric ?? "";
    message.device = object.device ?? "";
    message.port = object.port ?? "";
    message.assertType = object.assertType?.map((e) => e) || [];
    message.counterType = object.counterType?.map((e) => e) || [];
    message.category = object.category?.map((e) => e) || [];
    message.objectTypes = object.objectTypes?.map((e) => e) || [];
    message.operation = object.operation?.map((e) => e) || [];
    return message;
  },
};

function createBaseAssertCounterReport(): AssertCounterReport {
  return {
    device: "",
    portName: "",
    type: "",
    newFalseAsserts: 0,
    clearedFalseAsserts: 0,
    configActivities: 0,
    timestamp: undefined,
    category: "",
    swConfigActivities: 0,
  };
}

export const AssertCounterReport: MessageFns<AssertCounterReport> = {
  encode(message: AssertCounterReport, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.device !== "") {
      writer.uint32(10).string(message.device);
    }
    if (message.portName !== "") {
      writer.uint32(18).string(message.portName);
    }
    if (message.type !== "") {
      writer.uint32(26).string(message.type);
    }
    if (message.newFalseAsserts !== 0) {
      writer.uint32(32).uint32(message.newFalseAsserts);
    }
    if (message.clearedFalseAsserts !== 0) {
      writer.uint32(40).uint32(message.clearedFalseAsserts);
    }
    if (message.configActivities !== 0) {
      writer.uint32(56).uint32(message.configActivities);
    }
    if (message.timestamp !== undefined) {
      Timestamp.encode(toTimestamp(message.timestamp), writer.uint32(50).fork()).join();
    }
    if (message.category !== "") {
      writer.uint32(66).string(message.category);
    }
    if (message.swConfigActivities !== 0) {
      writer.uint32(72).uint32(message.swConfigActivities);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertCounterReport {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertCounterReport();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.device = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.portName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.newFalseAsserts = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.clearedFalseAsserts = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.configActivities = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.timestamp = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.category = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.swConfigActivities = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertCounterReport {
    return {
      device: isSet(object.device) ? globalThis.String(object.device) : "",
      portName: isSet(object.portName) ? globalThis.String(object.portName) : "",
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      newFalseAsserts: isSet(object.newFalseAsserts) ? globalThis.Number(object.newFalseAsserts) : 0,
      clearedFalseAsserts: isSet(object.clearedFalseAsserts) ? globalThis.Number(object.clearedFalseAsserts) : 0,
      configActivities: isSet(object.configActivities) ? globalThis.Number(object.configActivities) : 0,
      timestamp: isSet(object.timestamp) ? fromJsonTimestamp(object.timestamp) : undefined,
      category: isSet(object.category) ? globalThis.String(object.category) : "",
      swConfigActivities: isSet(object.swConfigActivities) ? globalThis.Number(object.swConfigActivities) : 0,
    };
  },

  toJSON(message: AssertCounterReport): unknown {
    const obj: any = {};
    if (message.device !== "") {
      obj.device = message.device;
    }
    if (message.portName !== "") {
      obj.portName = message.portName;
    }
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.newFalseAsserts !== 0) {
      obj.newFalseAsserts = Math.round(message.newFalseAsserts);
    }
    if (message.clearedFalseAsserts !== 0) {
      obj.clearedFalseAsserts = Math.round(message.clearedFalseAsserts);
    }
    if (message.configActivities !== 0) {
      obj.configActivities = Math.round(message.configActivities);
    }
    if (message.timestamp !== undefined) {
      obj.timestamp = message.timestamp.toISOString();
    }
    if (message.category !== "") {
      obj.category = message.category;
    }
    if (message.swConfigActivities !== 0) {
      obj.swConfigActivities = Math.round(message.swConfigActivities);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertCounterReport>, I>>(base?: I): AssertCounterReport {
    return AssertCounterReport.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertCounterReport>, I>>(object: I): AssertCounterReport {
    const message = createBaseAssertCounterReport();
    message.device = object.device ?? "";
    message.portName = object.portName ?? "";
    message.type = object.type ?? "";
    message.newFalseAsserts = object.newFalseAsserts ?? 0;
    message.clearedFalseAsserts = object.clearedFalseAsserts ?? 0;
    message.configActivities = object.configActivities ?? 0;
    message.timestamp = object.timestamp ?? undefined;
    message.category = object.category ?? "";
    message.swConfigActivities = object.swConfigActivities ?? 0;
    return message;
  },
};

function createBaseAssertCounterReportResponse(): AssertCounterReportResponse {
  return { counterReport: [], pagination: undefined };
}

export const AssertCounterReportResponse: MessageFns<AssertCounterReportResponse> = {
  encode(message: AssertCounterReportResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.counterReport) {
      AssertCounterReport.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.pagination !== undefined) {
      PaginationResponse.encode(message.pagination, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertCounterReportResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertCounterReportResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.counterReport.push(AssertCounterReport.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pagination = PaginationResponse.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertCounterReportResponse {
    return {
      counterReport: globalThis.Array.isArray(object?.counterReport)
        ? object.counterReport.map((e: any) => AssertCounterReport.fromJSON(e))
        : [],
      pagination: isSet(object.pagination) ? PaginationResponse.fromJSON(object.pagination) : undefined,
    };
  },

  toJSON(message: AssertCounterReportResponse): unknown {
    const obj: any = {};
    if (message.counterReport?.length) {
      obj.counterReport = message.counterReport.map((e) => AssertCounterReport.toJSON(e));
    }
    if (message.pagination !== undefined) {
      obj.pagination = PaginationResponse.toJSON(message.pagination);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertCounterReportResponse>, I>>(base?: I): AssertCounterReportResponse {
    return AssertCounterReportResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertCounterReportResponse>, I>>(object: I): AssertCounterReportResponse {
    const message = createBaseAssertCounterReportResponse();
    message.counterReport = object.counterReport?.map((e) => AssertCounterReport.fromPartial(e)) || [];
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationResponse.fromPartial(object.pagination)
      : undefined;
    return message;
  },
};

function createBaseAssertRestRecordRequest(): AssertRestRecordRequest {
  return {
    startTime: "",
    endTime: "",
    granularity: 0,
    limit: 0,
    fabric: "",
    device: "",
    port: "",
    assertType: [],
    counterType: [],
    category: [],
    objectTypes: [],
  };
}

export const AssertRestRecordRequest: MessageFns<AssertRestRecordRequest> = {
  encode(message: AssertRestRecordRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.startTime !== "") {
      writer.uint32(18).string(message.startTime);
    }
    if (message.endTime !== "") {
      writer.uint32(26).string(message.endTime);
    }
    if (message.granularity !== 0) {
      writer.uint32(32).int32(message.granularity);
    }
    if (message.limit !== 0) {
      writer.uint32(40).uint32(message.limit);
    }
    if (message.fabric !== "") {
      writer.uint32(50).string(message.fabric);
    }
    if (message.device !== "") {
      writer.uint32(58).string(message.device);
    }
    if (message.port !== "") {
      writer.uint32(66).string(message.port);
    }
    for (const v of message.assertType) {
      writer.uint32(74).string(v!);
    }
    writer.uint32(82).fork();
    for (const v of message.counterType) {
      writer.int32(v);
    }
    writer.join();
    writer.uint32(90).fork();
    for (const v of message.category) {
      writer.int32(v);
    }
    writer.join();
    writer.uint32(98).fork();
    for (const v of message.objectTypes) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertRestRecordRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertRestRecordRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.startTime = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.endTime = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.granularity = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.limit = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.fabric = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.device = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.port = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.assertType.push(reader.string());
          continue;
        }
        case 10: {
          if (tag === 80) {
            message.counterType.push(reader.int32() as any);

            continue;
          }

          if (tag === 82) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.counterType.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 11: {
          if (tag === 88) {
            message.category.push(reader.int32() as any);

            continue;
          }

          if (tag === 90) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.category.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 12: {
          if (tag === 96) {
            message.objectTypes.push(reader.int32() as any);

            continue;
          }

          if (tag === 98) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.objectTypes.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertRestRecordRequest {
    return {
      startTime: isSet(object.startTime) ? globalThis.String(object.startTime) : "",
      endTime: isSet(object.endTime) ? globalThis.String(object.endTime) : "",
      granularity: isSet(object.granularity) ? granularityFromJSON(object.granularity) : 0,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : 0,
      fabric: isSet(object.fabric) ? globalThis.String(object.fabric) : "",
      device: isSet(object.device) ? globalThis.String(object.device) : "",
      port: isSet(object.port) ? globalThis.String(object.port) : "",
      assertType: globalThis.Array.isArray(object?.assertType)
        ? object.assertType.map((e: any) => globalThis.String(e))
        : [],
      counterType: globalThis.Array.isArray(object?.counterType)
        ? object.counterType.map((e: any) => assertCounterTypeFromJSON(e))
        : [],
      category: globalThis.Array.isArray(object?.category)
        ? object.category.map((e: any) => assertCategoryTypeFromJSON(e))
        : [],
      objectTypes: globalThis.Array.isArray(object?.objectTypes)
        ? object.objectTypes.map((e: any) => objectTypeFromJSON(e))
        : [],
    };
  },

  toJSON(message: AssertRestRecordRequest): unknown {
    const obj: any = {};
    if (message.startTime !== "") {
      obj.startTime = message.startTime;
    }
    if (message.endTime !== "") {
      obj.endTime = message.endTime;
    }
    if (message.granularity !== 0) {
      obj.granularity = granularityToJSON(message.granularity);
    }
    if (message.limit !== 0) {
      obj.limit = Math.round(message.limit);
    }
    if (message.fabric !== "") {
      obj.fabric = message.fabric;
    }
    if (message.device !== "") {
      obj.device = message.device;
    }
    if (message.port !== "") {
      obj.port = message.port;
    }
    if (message.assertType?.length) {
      obj.assertType = message.assertType;
    }
    if (message.counterType?.length) {
      obj.counterType = message.counterType.map((e) => assertCounterTypeToJSON(e));
    }
    if (message.category?.length) {
      obj.category = message.category.map((e) => assertCategoryTypeToJSON(e));
    }
    if (message.objectTypes?.length) {
      obj.objectTypes = message.objectTypes.map((e) => objectTypeToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertRestRecordRequest>, I>>(base?: I): AssertRestRecordRequest {
    return AssertRestRecordRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertRestRecordRequest>, I>>(object: I): AssertRestRecordRequest {
    const message = createBaseAssertRestRecordRequest();
    message.startTime = object.startTime ?? "";
    message.endTime = object.endTime ?? "";
    message.granularity = object.granularity ?? 0;
    message.limit = object.limit ?? 0;
    message.fabric = object.fabric ?? "";
    message.device = object.device ?? "";
    message.port = object.port ?? "";
    message.assertType = object.assertType?.map((e) => e) || [];
    message.counterType = object.counterType?.map((e) => e) || [];
    message.category = object.category?.map((e) => e) || [];
    message.objectTypes = object.objectTypes?.map((e) => e) || [];
    return message;
  },
};

function createBaseAssertHistoryApiRecordResponse(): AssertHistoryApiRecordResponse {
  return { assertions: [], pagination: undefined };
}

export const AssertHistoryApiRecordResponse: MessageFns<AssertHistoryApiRecordResponse> = {
  encode(message: AssertHistoryApiRecordResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.assertions) {
      AssertHistoryApiRecord.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.pagination !== undefined) {
      PaginationResponse.encode(message.pagination, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertHistoryApiRecordResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertHistoryApiRecordResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.assertions.push(AssertHistoryApiRecord.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pagination = PaginationResponse.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertHistoryApiRecordResponse {
    return {
      assertions: globalThis.Array.isArray(object?.assertions)
        ? object.assertions.map((e: any) => AssertHistoryApiRecord.fromJSON(e))
        : [],
      pagination: isSet(object.pagination) ? PaginationResponse.fromJSON(object.pagination) : undefined,
    };
  },

  toJSON(message: AssertHistoryApiRecordResponse): unknown {
    const obj: any = {};
    if (message.assertions?.length) {
      obj.assertions = message.assertions.map((e) => AssertHistoryApiRecord.toJSON(e));
    }
    if (message.pagination !== undefined) {
      obj.pagination = PaginationResponse.toJSON(message.pagination);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertHistoryApiRecordResponse>, I>>(base?: I): AssertHistoryApiRecordResponse {
    return AssertHistoryApiRecordResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertHistoryApiRecordResponse>, I>>(
    object: I,
  ): AssertHistoryApiRecordResponse {
    const message = createBaseAssertHistoryApiRecordResponse();
    message.assertions = object.assertions?.map((e) => AssertHistoryApiRecord.fromPartial(e)) || [];
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationResponse.fromPartial(object.pagination)
      : undefined;
    return message;
  },
};

function createBaseHistoryResponse(): HistoryResponse {
  return {
    queryType: 0,
    portStateResponse: undefined,
    portCounterResponse: undefined,
    assertCounterReport: undefined,
    assertResponse: undefined,
    assertApiResponse: undefined,
    data: undefined,
  };
}

export const HistoryResponse: MessageFns<HistoryResponse> = {
  encode(message: HistoryResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.queryType !== 0) {
      writer.uint32(8).int32(message.queryType);
    }
    if (message.portStateResponse !== undefined) {
      PortStateHistoryRecordResponse.encode(message.portStateResponse, writer.uint32(18).fork()).join();
    }
    if (message.portCounterResponse !== undefined) {
      PortCounterHistoryRecordResponse.encode(message.portCounterResponse, writer.uint32(26).fork()).join();
    }
    if (message.assertCounterReport !== undefined) {
      AssertCounterReportResponse.encode(message.assertCounterReport, writer.uint32(34).fork()).join();
    }
    if (message.assertResponse !== undefined) {
      AssertHistoryRecordResponse.encode(message.assertResponse, writer.uint32(42).fork()).join();
    }
    if (message.assertApiResponse !== undefined) {
      AssertHistoryApiRecordResponse.encode(message.assertApiResponse, writer.uint32(50).fork()).join();
    }
    if (message.data !== undefined) {
      MetricsData.encode(message.data, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HistoryResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHistoryResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.queryType = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.portStateResponse = PortStateHistoryRecordResponse.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.portCounterResponse = PortCounterHistoryRecordResponse.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.assertCounterReport = AssertCounterReportResponse.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.assertResponse = AssertHistoryRecordResponse.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.assertApiResponse = AssertHistoryApiRecordResponse.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.data = MetricsData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HistoryResponse {
    return {
      queryType: isSet(object.queryType) ? queryTypeFromJSON(object.queryType) : 0,
      portStateResponse: isSet(object.portStateResponse)
        ? PortStateHistoryRecordResponse.fromJSON(object.portStateResponse)
        : undefined,
      portCounterResponse: isSet(object.portCounterResponse)
        ? PortCounterHistoryRecordResponse.fromJSON(object.portCounterResponse)
        : undefined,
      assertCounterReport: isSet(object.assertCounterReport)
        ? AssertCounterReportResponse.fromJSON(object.assertCounterReport)
        : undefined,
      assertResponse: isSet(object.assertResponse)
        ? AssertHistoryRecordResponse.fromJSON(object.assertResponse)
        : undefined,
      assertApiResponse: isSet(object.assertApiResponse)
        ? AssertHistoryApiRecordResponse.fromJSON(object.assertApiResponse)
        : undefined,
      data: isSet(object.data) ? MetricsData.fromJSON(object.data) : undefined,
    };
  },

  toJSON(message: HistoryResponse): unknown {
    const obj: any = {};
    if (message.queryType !== 0) {
      obj.queryType = queryTypeToJSON(message.queryType);
    }
    if (message.portStateResponse !== undefined) {
      obj.portStateResponse = PortStateHistoryRecordResponse.toJSON(message.portStateResponse);
    }
    if (message.portCounterResponse !== undefined) {
      obj.portCounterResponse = PortCounterHistoryRecordResponse.toJSON(message.portCounterResponse);
    }
    if (message.assertCounterReport !== undefined) {
      obj.assertCounterReport = AssertCounterReportResponse.toJSON(message.assertCounterReport);
    }
    if (message.assertResponse !== undefined) {
      obj.assertResponse = AssertHistoryRecordResponse.toJSON(message.assertResponse);
    }
    if (message.assertApiResponse !== undefined) {
      obj.assertApiResponse = AssertHistoryApiRecordResponse.toJSON(message.assertApiResponse);
    }
    if (message.data !== undefined) {
      obj.data = MetricsData.toJSON(message.data);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HistoryResponse>, I>>(base?: I): HistoryResponse {
    return HistoryResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HistoryResponse>, I>>(object: I): HistoryResponse {
    const message = createBaseHistoryResponse();
    message.queryType = object.queryType ?? 0;
    message.portStateResponse = (object.portStateResponse !== undefined && object.portStateResponse !== null)
      ? PortStateHistoryRecordResponse.fromPartial(object.portStateResponse)
      : undefined;
    message.portCounterResponse = (object.portCounterResponse !== undefined && object.portCounterResponse !== null)
      ? PortCounterHistoryRecordResponse.fromPartial(object.portCounterResponse)
      : undefined;
    message.assertCounterReport = (object.assertCounterReport !== undefined && object.assertCounterReport !== null)
      ? AssertCounterReportResponse.fromPartial(object.assertCounterReport)
      : undefined;
    message.assertResponse = (object.assertResponse !== undefined && object.assertResponse !== null)
      ? AssertHistoryRecordResponse.fromPartial(object.assertResponse)
      : undefined;
    message.assertApiResponse = (object.assertApiResponse !== undefined && object.assertApiResponse !== null)
      ? AssertHistoryApiRecordResponse.fromPartial(object.assertApiResponse)
      : undefined;
    message.data = (object.data !== undefined && object.data !== null)
      ? MetricsData.fromPartial(object.data)
      : undefined;
    return message;
  },
};

function createBaseMetricsData(): MetricsData {
  return { timeseries: [], totalCount: 0 };
}

export const MetricsData: MessageFns<MetricsData> = {
  encode(message: MetricsData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.timeseries) {
      MetricsTimeseries.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.totalCount !== 0) {
      writer.uint32(16).uint32(message.totalCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MetricsData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMetricsData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.timeseries.push(MetricsTimeseries.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.totalCount = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MetricsData {
    return {
      timeseries: globalThis.Array.isArray(object?.timeseries)
        ? object.timeseries.map((e: any) => MetricsTimeseries.fromJSON(e))
        : [],
      totalCount: isSet(object.totalCount) ? globalThis.Number(object.totalCount) : 0,
    };
  },

  toJSON(message: MetricsData): unknown {
    const obj: any = {};
    if (message.timeseries?.length) {
      obj.timeseries = message.timeseries.map((e) => MetricsTimeseries.toJSON(e));
    }
    if (message.totalCount !== 0) {
      obj.totalCount = Math.round(message.totalCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MetricsData>, I>>(base?: I): MetricsData {
    return MetricsData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MetricsData>, I>>(object: I): MetricsData {
    const message = createBaseMetricsData();
    message.timeseries = object.timeseries?.map((e) => MetricsTimeseries.fromPartial(e)) || [];
    message.totalCount = object.totalCount ?? 0;
    return message;
  },
};

function createBaseDeviceMetricsFilter(): DeviceMetricsFilter {
  return { device: "", deviceType: 0, portNames: [] };
}

export const DeviceMetricsFilter: MessageFns<DeviceMetricsFilter> = {
  encode(message: DeviceMetricsFilter, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.device !== "") {
      writer.uint32(10).string(message.device);
    }
    if (message.deviceType !== 0) {
      writer.uint32(16).int32(message.deviceType);
    }
    for (const v of message.portNames) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeviceMetricsFilter {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeviceMetricsFilter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.device = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.deviceType = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.portNames.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeviceMetricsFilter {
    return {
      device: isSet(object.device) ? globalThis.String(object.device) : "",
      deviceType: isSet(object.deviceType) ? nodeTypeFromJSON(object.deviceType) : 0,
      portNames: globalThis.Array.isArray(object?.portNames)
        ? object.portNames.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: DeviceMetricsFilter): unknown {
    const obj: any = {};
    if (message.device !== "") {
      obj.device = message.device;
    }
    if (message.deviceType !== 0) {
      obj.deviceType = nodeTypeToJSON(message.deviceType);
    }
    if (message.portNames?.length) {
      obj.portNames = message.portNames;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeviceMetricsFilter>, I>>(base?: I): DeviceMetricsFilter {
    return DeviceMetricsFilter.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeviceMetricsFilter>, I>>(object: I): DeviceMetricsFilter {
    const message = createBaseDeviceMetricsFilter();
    message.device = object.device ?? "";
    message.deviceType = object.deviceType ?? 0;
    message.portNames = object.portNames?.map((e) => e) || [];
    return message;
  },
};

function createBaseMetricsTimeseries(): MetricsTimeseries {
  return { deviceId: "", portName: "", dataPoints: [] };
}

export const MetricsTimeseries: MessageFns<MetricsTimeseries> = {
  encode(message: MetricsTimeseries, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deviceId !== "") {
      writer.uint32(10).string(message.deviceId);
    }
    if (message.portName !== "") {
      writer.uint32(18).string(message.portName);
    }
    for (const v of message.dataPoints) {
      MetricDataPoint.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MetricsTimeseries {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMetricsTimeseries();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.portName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.dataPoints.push(MetricDataPoint.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MetricsTimeseries {
    return {
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      portName: isSet(object.portName) ? globalThis.String(object.portName) : "",
      dataPoints: globalThis.Array.isArray(object?.dataPoints)
        ? object.dataPoints.map((e: any) => MetricDataPoint.fromJSON(e))
        : [],
    };
  },

  toJSON(message: MetricsTimeseries): unknown {
    const obj: any = {};
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.portName !== "") {
      obj.portName = message.portName;
    }
    if (message.dataPoints?.length) {
      obj.dataPoints = message.dataPoints.map((e) => MetricDataPoint.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MetricsTimeseries>, I>>(base?: I): MetricsTimeseries {
    return MetricsTimeseries.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MetricsTimeseries>, I>>(object: I): MetricsTimeseries {
    const message = createBaseMetricsTimeseries();
    message.deviceId = object.deviceId ?? "";
    message.portName = object.portName ?? "";
    message.dataPoints = object.dataPoints?.map((e) => MetricDataPoint.fromPartial(e)) || [];
    return message;
  },
};

function createBaseMetricDataPoint(): MetricDataPoint {
  return { timestamp: undefined, metrics: [] };
}

export const MetricDataPoint: MessageFns<MetricDataPoint> = {
  encode(message: MetricDataPoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.timestamp !== undefined) {
      Timestamp.encode(toTimestamp(message.timestamp), writer.uint32(10).fork()).join();
    }
    writer.uint32(18).fork();
    for (const v of message.metrics) {
      writer.double(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MetricDataPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMetricDataPoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.timestamp = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag === 17) {
            message.metrics.push(reader.double());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.metrics.push(reader.double());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MetricDataPoint {
    return {
      timestamp: isSet(object.timestamp) ? fromJsonTimestamp(object.timestamp) : undefined,
      metrics: globalThis.Array.isArray(object?.metrics) ? object.metrics.map((e: any) => globalThis.Number(e)) : [],
    };
  },

  toJSON(message: MetricDataPoint): unknown {
    const obj: any = {};
    if (message.timestamp !== undefined) {
      obj.timestamp = message.timestamp.toISOString();
    }
    if (message.metrics?.length) {
      obj.metrics = message.metrics;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MetricDataPoint>, I>>(base?: I): MetricDataPoint {
    return MetricDataPoint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MetricDataPoint>, I>>(object: I): MetricDataPoint {
    const message = createBaseMetricDataPoint();
    message.timestamp = object.timestamp ?? undefined;
    message.metrics = object.metrics?.map((e) => e) || [];
    return message;
  },
};

function createBaseStringInList(): StringInList {
  return { values: [] };
}

export const StringInList: MessageFns<StringInList> = {
  encode(message: StringInList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.values) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StringInList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStringInList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.values.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StringInList {
    return {
      values: globalThis.Array.isArray(object?.values) ? object.values.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: StringInList): unknown {
    const obj: any = {};
    if (message.values?.length) {
      obj.values = message.values;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StringInList>, I>>(base?: I): StringInList {
    return StringInList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StringInList>, I>>(object: I): StringInList {
    const message = createBaseStringInList();
    message.values = object.values?.map((e) => e) || [];
    return message;
  },
};

function createBaseAssertTypeInList(): AssertTypeInList {
  return { values: [] };
}

export const AssertTypeInList: MessageFns<AssertTypeInList> = {
  encode(message: AssertTypeInList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.values) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertTypeInList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertTypeInList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.values.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertTypeInList {
    return {
      values: globalThis.Array.isArray(object?.values) ? object.values.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: AssertTypeInList): unknown {
    const obj: any = {};
    if (message.values?.length) {
      obj.values = message.values;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertTypeInList>, I>>(base?: I): AssertTypeInList {
    return AssertTypeInList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertTypeInList>, I>>(object: I): AssertTypeInList {
    const message = createBaseAssertTypeInList();
    message.values = object.values?.map((e) => e) || [];
    return message;
  },
};

function createBaseAssertStateInList(): AssertStateInList {
  return { values: [] };
}

export const AssertStateInList: MessageFns<AssertStateInList> = {
  encode(message: AssertStateInList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.values) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertStateInList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertStateInList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.values.push(reader.int32() as any);

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.values.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertStateInList {
    return {
      values: globalThis.Array.isArray(object?.values)
        ? object.values.map((e: any) => assertTransitionStatesFromJSON(e))
        : [],
    };
  },

  toJSON(message: AssertStateInList): unknown {
    const obj: any = {};
    if (message.values?.length) {
      obj.values = message.values.map((e) => assertTransitionStatesToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertStateInList>, I>>(base?: I): AssertStateInList {
    return AssertStateInList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertStateInList>, I>>(object: I): AssertStateInList {
    const message = createBaseAssertStateInList();
    message.values = object.values?.map((e) => e) || [];
    return message;
  },
};

function createBaseCategoryInList(): CategoryInList {
  return { values: [] };
}

export const CategoryInList: MessageFns<CategoryInList> = {
  encode(message: CategoryInList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.values) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CategoryInList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCategoryInList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.values.push(reader.int32() as any);

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.values.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CategoryInList {
    return {
      values: globalThis.Array.isArray(object?.values)
        ? object.values.map((e: any) => assertCategoryTypeFromJSON(e))
        : [],
    };
  },

  toJSON(message: CategoryInList): unknown {
    const obj: any = {};
    if (message.values?.length) {
      obj.values = message.values.map((e) => assertCategoryTypeToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CategoryInList>, I>>(base?: I): CategoryInList {
    return CategoryInList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CategoryInList>, I>>(object: I): CategoryInList {
    const message = createBaseCategoryInList();
    message.values = object.values?.map((e) => e) || [];
    return message;
  },
};

function createBaseOperationInList(): OperationInList {
  return { values: [] };
}

export const OperationInList: MessageFns<OperationInList> = {
  encode(message: OperationInList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.values) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OperationInList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOperationInList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.values.push(reader.int32() as any);

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.values.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OperationInList {
    return {
      values: globalThis.Array.isArray(object?.values) ? object.values.map((e: any) => operationFromJSON(e)) : [],
    };
  },

  toJSON(message: OperationInList): unknown {
    const obj: any = {};
    if (message.values?.length) {
      obj.values = message.values.map((e) => operationToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OperationInList>, I>>(base?: I): OperationInList {
    return OperationInList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OperationInList>, I>>(object: I): OperationInList {
    const message = createBaseOperationInList();
    message.values = object.values?.map((e) => e) || [];
    return message;
  },
};

function createBaseObjectTypeInList(): ObjectTypeInList {
  return { values: [] };
}

export const ObjectTypeInList: MessageFns<ObjectTypeInList> = {
  encode(message: ObjectTypeInList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.values) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ObjectTypeInList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseObjectTypeInList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.values.push(reader.int32() as any);

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.values.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ObjectTypeInList {
    return {
      values: globalThis.Array.isArray(object?.values) ? object.values.map((e: any) => objectTypeFromJSON(e)) : [],
    };
  },

  toJSON(message: ObjectTypeInList): unknown {
    const obj: any = {};
    if (message.values?.length) {
      obj.values = message.values.map((e) => objectTypeToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ObjectTypeInList>, I>>(base?: I): ObjectTypeInList {
    return ObjectTypeInList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ObjectTypeInList>, I>>(object: I): ObjectTypeInList {
    const message = createBaseObjectTypeInList();
    message.values = object.values?.map((e) => e) || [];
    return message;
  },
};

function createBaseAssertionHistoryFilterPredicate(): AssertionHistoryFilterPredicate {
  return {
    deviceIn: undefined,
    portNameIn: undefined,
    portIdIn: undefined,
    nodeIdIn: undefined,
    remoteNodeIdIn: undefined,
    remoteDeviceIn: undefined,
    usernameIn: undefined,
    txnIdIn: undefined,
    objectIdIn: undefined,
    objectNameIn: undefined,
    assertTypeIn: undefined,
    assertStateIn: undefined,
    categoryIn: undefined,
    operationIn: undefined,
    objectTypeIn: undefined,
  };
}

export const AssertionHistoryFilterPredicate: MessageFns<AssertionHistoryFilterPredicate> = {
  encode(message: AssertionHistoryFilterPredicate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deviceIn !== undefined) {
      StringInList.encode(message.deviceIn, writer.uint32(10).fork()).join();
    }
    if (message.portNameIn !== undefined) {
      StringInList.encode(message.portNameIn, writer.uint32(18).fork()).join();
    }
    if (message.portIdIn !== undefined) {
      StringInList.encode(message.portIdIn, writer.uint32(26).fork()).join();
    }
    if (message.nodeIdIn !== undefined) {
      StringInList.encode(message.nodeIdIn, writer.uint32(34).fork()).join();
    }
    if (message.remoteNodeIdIn !== undefined) {
      StringInList.encode(message.remoteNodeIdIn, writer.uint32(42).fork()).join();
    }
    if (message.remoteDeviceIn !== undefined) {
      StringInList.encode(message.remoteDeviceIn, writer.uint32(50).fork()).join();
    }
    if (message.usernameIn !== undefined) {
      StringInList.encode(message.usernameIn, writer.uint32(58).fork()).join();
    }
    if (message.txnIdIn !== undefined) {
      StringInList.encode(message.txnIdIn, writer.uint32(66).fork()).join();
    }
    if (message.objectIdIn !== undefined) {
      StringInList.encode(message.objectIdIn, writer.uint32(74).fork()).join();
    }
    if (message.objectNameIn !== undefined) {
      StringInList.encode(message.objectNameIn, writer.uint32(82).fork()).join();
    }
    if (message.assertTypeIn !== undefined) {
      AssertTypeInList.encode(message.assertTypeIn, writer.uint32(90).fork()).join();
    }
    if (message.assertStateIn !== undefined) {
      AssertStateInList.encode(message.assertStateIn, writer.uint32(98).fork()).join();
    }
    if (message.categoryIn !== undefined) {
      CategoryInList.encode(message.categoryIn, writer.uint32(106).fork()).join();
    }
    if (message.operationIn !== undefined) {
      OperationInList.encode(message.operationIn, writer.uint32(114).fork()).join();
    }
    if (message.objectTypeIn !== undefined) {
      ObjectTypeInList.encode(message.objectTypeIn, writer.uint32(122).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertionHistoryFilterPredicate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertionHistoryFilterPredicate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.deviceIn = StringInList.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.portNameIn = StringInList.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.portIdIn = StringInList.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.nodeIdIn = StringInList.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.remoteNodeIdIn = StringInList.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.remoteDeviceIn = StringInList.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.usernameIn = StringInList.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.txnIdIn = StringInList.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.objectIdIn = StringInList.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.objectNameIn = StringInList.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.assertTypeIn = AssertTypeInList.decode(reader, reader.uint32());
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.assertStateIn = AssertStateInList.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.categoryIn = CategoryInList.decode(reader, reader.uint32());
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.operationIn = OperationInList.decode(reader, reader.uint32());
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.objectTypeIn = ObjectTypeInList.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertionHistoryFilterPredicate {
    return {
      deviceIn: isSet(object.deviceIn) ? StringInList.fromJSON(object.deviceIn) : undefined,
      portNameIn: isSet(object.portNameIn) ? StringInList.fromJSON(object.portNameIn) : undefined,
      portIdIn: isSet(object.portIdIn) ? StringInList.fromJSON(object.portIdIn) : undefined,
      nodeIdIn: isSet(object.nodeIdIn) ? StringInList.fromJSON(object.nodeIdIn) : undefined,
      remoteNodeIdIn: isSet(object.remoteNodeIdIn) ? StringInList.fromJSON(object.remoteNodeIdIn) : undefined,
      remoteDeviceIn: isSet(object.remoteDeviceIn) ? StringInList.fromJSON(object.remoteDeviceIn) : undefined,
      usernameIn: isSet(object.usernameIn) ? StringInList.fromJSON(object.usernameIn) : undefined,
      txnIdIn: isSet(object.txnIdIn) ? StringInList.fromJSON(object.txnIdIn) : undefined,
      objectIdIn: isSet(object.objectIdIn) ? StringInList.fromJSON(object.objectIdIn) : undefined,
      objectNameIn: isSet(object.objectNameIn) ? StringInList.fromJSON(object.objectNameIn) : undefined,
      assertTypeIn: isSet(object.assertTypeIn) ? AssertTypeInList.fromJSON(object.assertTypeIn) : undefined,
      assertStateIn: isSet(object.assertStateIn) ? AssertStateInList.fromJSON(object.assertStateIn) : undefined,
      categoryIn: isSet(object.categoryIn) ? CategoryInList.fromJSON(object.categoryIn) : undefined,
      operationIn: isSet(object.operationIn) ? OperationInList.fromJSON(object.operationIn) : undefined,
      objectTypeIn: isSet(object.objectTypeIn) ? ObjectTypeInList.fromJSON(object.objectTypeIn) : undefined,
    };
  },

  toJSON(message: AssertionHistoryFilterPredicate): unknown {
    const obj: any = {};
    if (message.deviceIn !== undefined) {
      obj.deviceIn = StringInList.toJSON(message.deviceIn);
    }
    if (message.portNameIn !== undefined) {
      obj.portNameIn = StringInList.toJSON(message.portNameIn);
    }
    if (message.portIdIn !== undefined) {
      obj.portIdIn = StringInList.toJSON(message.portIdIn);
    }
    if (message.nodeIdIn !== undefined) {
      obj.nodeIdIn = StringInList.toJSON(message.nodeIdIn);
    }
    if (message.remoteNodeIdIn !== undefined) {
      obj.remoteNodeIdIn = StringInList.toJSON(message.remoteNodeIdIn);
    }
    if (message.remoteDeviceIn !== undefined) {
      obj.remoteDeviceIn = StringInList.toJSON(message.remoteDeviceIn);
    }
    if (message.usernameIn !== undefined) {
      obj.usernameIn = StringInList.toJSON(message.usernameIn);
    }
    if (message.txnIdIn !== undefined) {
      obj.txnIdIn = StringInList.toJSON(message.txnIdIn);
    }
    if (message.objectIdIn !== undefined) {
      obj.objectIdIn = StringInList.toJSON(message.objectIdIn);
    }
    if (message.objectNameIn !== undefined) {
      obj.objectNameIn = StringInList.toJSON(message.objectNameIn);
    }
    if (message.assertTypeIn !== undefined) {
      obj.assertTypeIn = AssertTypeInList.toJSON(message.assertTypeIn);
    }
    if (message.assertStateIn !== undefined) {
      obj.assertStateIn = AssertStateInList.toJSON(message.assertStateIn);
    }
    if (message.categoryIn !== undefined) {
      obj.categoryIn = CategoryInList.toJSON(message.categoryIn);
    }
    if (message.operationIn !== undefined) {
      obj.operationIn = OperationInList.toJSON(message.operationIn);
    }
    if (message.objectTypeIn !== undefined) {
      obj.objectTypeIn = ObjectTypeInList.toJSON(message.objectTypeIn);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertionHistoryFilterPredicate>, I>>(base?: I): AssertionHistoryFilterPredicate {
    return AssertionHistoryFilterPredicate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertionHistoryFilterPredicate>, I>>(
    object: I,
  ): AssertionHistoryFilterPredicate {
    const message = createBaseAssertionHistoryFilterPredicate();
    message.deviceIn = (object.deviceIn !== undefined && object.deviceIn !== null)
      ? StringInList.fromPartial(object.deviceIn)
      : undefined;
    message.portNameIn = (object.portNameIn !== undefined && object.portNameIn !== null)
      ? StringInList.fromPartial(object.portNameIn)
      : undefined;
    message.portIdIn = (object.portIdIn !== undefined && object.portIdIn !== null)
      ? StringInList.fromPartial(object.portIdIn)
      : undefined;
    message.nodeIdIn = (object.nodeIdIn !== undefined && object.nodeIdIn !== null)
      ? StringInList.fromPartial(object.nodeIdIn)
      : undefined;
    message.remoteNodeIdIn = (object.remoteNodeIdIn !== undefined && object.remoteNodeIdIn !== null)
      ? StringInList.fromPartial(object.remoteNodeIdIn)
      : undefined;
    message.remoteDeviceIn = (object.remoteDeviceIn !== undefined && object.remoteDeviceIn !== null)
      ? StringInList.fromPartial(object.remoteDeviceIn)
      : undefined;
    message.usernameIn = (object.usernameIn !== undefined && object.usernameIn !== null)
      ? StringInList.fromPartial(object.usernameIn)
      : undefined;
    message.txnIdIn = (object.txnIdIn !== undefined && object.txnIdIn !== null)
      ? StringInList.fromPartial(object.txnIdIn)
      : undefined;
    message.objectIdIn = (object.objectIdIn !== undefined && object.objectIdIn !== null)
      ? StringInList.fromPartial(object.objectIdIn)
      : undefined;
    message.objectNameIn = (object.objectNameIn !== undefined && object.objectNameIn !== null)
      ? StringInList.fromPartial(object.objectNameIn)
      : undefined;
    message.assertTypeIn = (object.assertTypeIn !== undefined && object.assertTypeIn !== null)
      ? AssertTypeInList.fromPartial(object.assertTypeIn)
      : undefined;
    message.assertStateIn = (object.assertStateIn !== undefined && object.assertStateIn !== null)
      ? AssertStateInList.fromPartial(object.assertStateIn)
      : undefined;
    message.categoryIn = (object.categoryIn !== undefined && object.categoryIn !== null)
      ? CategoryInList.fromPartial(object.categoryIn)
      : undefined;
    message.operationIn = (object.operationIn !== undefined && object.operationIn !== null)
      ? OperationInList.fromPartial(object.operationIn)
      : undefined;
    message.objectTypeIn = (object.objectTypeIn !== undefined && object.objectTypeIn !== null)
      ? ObjectTypeInList.fromPartial(object.objectTypeIn)
      : undefined;
    return message;
  },
};

function createBaseAssertionHistoryFilterBranch(): AssertionHistoryFilterBranch {
  return { predicates: [] };
}

export const AssertionHistoryFilterBranch: MessageFns<AssertionHistoryFilterBranch> = {
  encode(message: AssertionHistoryFilterBranch, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.predicates) {
      AssertionHistoryFilterPredicate.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertionHistoryFilterBranch {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertionHistoryFilterBranch();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.predicates.push(AssertionHistoryFilterPredicate.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertionHistoryFilterBranch {
    return {
      predicates: globalThis.Array.isArray(object?.predicates)
        ? object.predicates.map((e: any) => AssertionHistoryFilterPredicate.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AssertionHistoryFilterBranch): unknown {
    const obj: any = {};
    if (message.predicates?.length) {
      obj.predicates = message.predicates.map((e) => AssertionHistoryFilterPredicate.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertionHistoryFilterBranch>, I>>(base?: I): AssertionHistoryFilterBranch {
    return AssertionHistoryFilterBranch.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertionHistoryFilterBranch>, I>>(object: I): AssertionHistoryFilterBranch {
    const message = createBaseAssertionHistoryFilterBranch();
    message.predicates = object.predicates?.map((e) => AssertionHistoryFilterPredicate.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAssertionHistoryQueryRequest(): AssertionHistoryQueryRequest {
  return {
    startTime: undefined,
    endTime: undefined,
    fabrics: [],
    branches: [],
    selectFields: [],
    limit: 0,
    granularity: 0,
  };
}

export const AssertionHistoryQueryRequest: MessageFns<AssertionHistoryQueryRequest> = {
  encode(message: AssertionHistoryQueryRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.startTime !== undefined) {
      Timestamp.encode(toTimestamp(message.startTime), writer.uint32(10).fork()).join();
    }
    if (message.endTime !== undefined) {
      Timestamp.encode(toTimestamp(message.endTime), writer.uint32(18).fork()).join();
    }
    for (const v of message.fabrics) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.branches) {
      AssertionHistoryFilterBranch.encode(v!, writer.uint32(34).fork()).join();
    }
    writer.uint32(42).fork();
    for (const v of message.selectFields) {
      writer.int32(v);
    }
    writer.join();
    if (message.limit !== 0) {
      writer.uint32(48).uint32(message.limit);
    }
    if (message.granularity !== 0) {
      writer.uint32(56).int32(message.granularity);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertionHistoryQueryRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertionHistoryQueryRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.startTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.endTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.fabrics.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.branches.push(AssertionHistoryFilterBranch.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag === 40) {
            message.selectFields.push(reader.int32() as any);

            continue;
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.selectFields.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.limit = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.granularity = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertionHistoryQueryRequest {
    return {
      startTime: isSet(object.startTime) ? fromJsonTimestamp(object.startTime) : undefined,
      endTime: isSet(object.endTime) ? fromJsonTimestamp(object.endTime) : undefined,
      fabrics: globalThis.Array.isArray(object?.fabrics) ? object.fabrics.map((e: any) => globalThis.String(e)) : [],
      branches: globalThis.Array.isArray(object?.branches)
        ? object.branches.map((e: any) => AssertionHistoryFilterBranch.fromJSON(e))
        : [],
      selectFields: globalThis.Array.isArray(object?.selectFields)
        ? object.selectFields.map((e: any) => assertionHistorySelectFieldFromJSON(e))
        : [],
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : 0,
      granularity: isSet(object.granularity) ? granularityFromJSON(object.granularity) : 0,
    };
  },

  toJSON(message: AssertionHistoryQueryRequest): unknown {
    const obj: any = {};
    if (message.startTime !== undefined) {
      obj.startTime = message.startTime.toISOString();
    }
    if (message.endTime !== undefined) {
      obj.endTime = message.endTime.toISOString();
    }
    if (message.fabrics?.length) {
      obj.fabrics = message.fabrics;
    }
    if (message.branches?.length) {
      obj.branches = message.branches.map((e) => AssertionHistoryFilterBranch.toJSON(e));
    }
    if (message.selectFields?.length) {
      obj.selectFields = message.selectFields.map((e) => assertionHistorySelectFieldToJSON(e));
    }
    if (message.limit !== 0) {
      obj.limit = Math.round(message.limit);
    }
    if (message.granularity !== 0) {
      obj.granularity = granularityToJSON(message.granularity);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertionHistoryQueryRequest>, I>>(base?: I): AssertionHistoryQueryRequest {
    return AssertionHistoryQueryRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertionHistoryQueryRequest>, I>>(object: I): AssertionHistoryQueryRequest {
    const message = createBaseAssertionHistoryQueryRequest();
    message.startTime = object.startTime ?? undefined;
    message.endTime = object.endTime ?? undefined;
    message.fabrics = object.fabrics?.map((e) => e) || [];
    message.branches = object.branches?.map((e) => AssertionHistoryFilterBranch.fromPartial(e)) || [];
    message.selectFields = object.selectFields?.map((e) => e) || [];
    message.limit = object.limit ?? 0;
    message.granularity = object.granularity ?? 0;
    return message;
  },
};

function createBaseAssertionHistoryQueryRow(): AssertionHistoryQueryRow {
  return {
    time: undefined,
    assertType: "",
    assertState: 0,
    operation: 0,
    device: "",
    portName: "",
    portId: "",
    nodeId: "",
    remoteNodeId: "",
    remoteDevice: "",
    fabric: "",
    username: "",
    txnId: "",
    category: 0,
    objectType: 0,
    objectId: "",
    objectName: "",
  };
}

export const AssertionHistoryQueryRow: MessageFns<AssertionHistoryQueryRow> = {
  encode(message: AssertionHistoryQueryRow, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.time !== undefined) {
      Timestamp.encode(toTimestamp(message.time), writer.uint32(10).fork()).join();
    }
    if (message.assertType !== "") {
      writer.uint32(18).string(message.assertType);
    }
    if (message.assertState !== 0) {
      writer.uint32(24).int32(message.assertState);
    }
    if (message.operation !== 0) {
      writer.uint32(32).int32(message.operation);
    }
    if (message.device !== "") {
      writer.uint32(42).string(message.device);
    }
    if (message.portName !== "") {
      writer.uint32(50).string(message.portName);
    }
    if (message.portId !== "") {
      writer.uint32(58).string(message.portId);
    }
    if (message.nodeId !== "") {
      writer.uint32(66).string(message.nodeId);
    }
    if (message.remoteNodeId !== "") {
      writer.uint32(74).string(message.remoteNodeId);
    }
    if (message.remoteDevice !== "") {
      writer.uint32(82).string(message.remoteDevice);
    }
    if (message.fabric !== "") {
      writer.uint32(90).string(message.fabric);
    }
    if (message.username !== "") {
      writer.uint32(98).string(message.username);
    }
    if (message.txnId !== "") {
      writer.uint32(106).string(message.txnId);
    }
    if (message.category !== 0) {
      writer.uint32(112).int32(message.category);
    }
    if (message.objectType !== 0) {
      writer.uint32(120).int32(message.objectType);
    }
    if (message.objectId !== "") {
      writer.uint32(130).string(message.objectId);
    }
    if (message.objectName !== "") {
      writer.uint32(138).string(message.objectName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertionHistoryQueryRow {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertionHistoryQueryRow();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.time = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.assertType = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.assertState = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.operation = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.device = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.portName = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.portId = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.remoteNodeId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.remoteDevice = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.fabric = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.username = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.txnId = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.objectType = reader.int32() as any;
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.objectId = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.objectName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertionHistoryQueryRow {
    return {
      time: isSet(object.time) ? fromJsonTimestamp(object.time) : undefined,
      assertType: isSet(object.assertType) ? globalThis.String(object.assertType) : "",
      assertState: isSet(object.assertState) ? assertTransitionStatesFromJSON(object.assertState) : 0,
      operation: isSet(object.operation) ? operationFromJSON(object.operation) : 0,
      device: isSet(object.device) ? globalThis.String(object.device) : "",
      portName: isSet(object.portName) ? globalThis.String(object.portName) : "",
      portId: isSet(object.portId) ? globalThis.String(object.portId) : "",
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      remoteNodeId: isSet(object.remoteNodeId) ? globalThis.String(object.remoteNodeId) : "",
      remoteDevice: isSet(object.remoteDevice) ? globalThis.String(object.remoteDevice) : "",
      fabric: isSet(object.fabric) ? globalThis.String(object.fabric) : "",
      username: isSet(object.username) ? globalThis.String(object.username) : "",
      txnId: isSet(object.txnId) ? globalThis.String(object.txnId) : "",
      category: isSet(object.category) ? assertCategoryTypeFromJSON(object.category) : 0,
      objectType: isSet(object.objectType) ? objectTypeFromJSON(object.objectType) : 0,
      objectId: isSet(object.objectId) ? globalThis.String(object.objectId) : "",
      objectName: isSet(object.objectName) ? globalThis.String(object.objectName) : "",
    };
  },

  toJSON(message: AssertionHistoryQueryRow): unknown {
    const obj: any = {};
    if (message.time !== undefined) {
      obj.time = message.time.toISOString();
    }
    if (message.assertType !== "") {
      obj.assertType = message.assertType;
    }
    if (message.assertState !== 0) {
      obj.assertState = assertTransitionStatesToJSON(message.assertState);
    }
    if (message.operation !== 0) {
      obj.operation = operationToJSON(message.operation);
    }
    if (message.device !== "") {
      obj.device = message.device;
    }
    if (message.portName !== "") {
      obj.portName = message.portName;
    }
    if (message.portId !== "") {
      obj.portId = message.portId;
    }
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.remoteNodeId !== "") {
      obj.remoteNodeId = message.remoteNodeId;
    }
    if (message.remoteDevice !== "") {
      obj.remoteDevice = message.remoteDevice;
    }
    if (message.fabric !== "") {
      obj.fabric = message.fabric;
    }
    if (message.username !== "") {
      obj.username = message.username;
    }
    if (message.txnId !== "") {
      obj.txnId = message.txnId;
    }
    if (message.category !== 0) {
      obj.category = assertCategoryTypeToJSON(message.category);
    }
    if (message.objectType !== 0) {
      obj.objectType = objectTypeToJSON(message.objectType);
    }
    if (message.objectId !== "") {
      obj.objectId = message.objectId;
    }
    if (message.objectName !== "") {
      obj.objectName = message.objectName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertionHistoryQueryRow>, I>>(base?: I): AssertionHistoryQueryRow {
    return AssertionHistoryQueryRow.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertionHistoryQueryRow>, I>>(object: I): AssertionHistoryQueryRow {
    const message = createBaseAssertionHistoryQueryRow();
    message.time = object.time ?? undefined;
    message.assertType = object.assertType ?? "";
    message.assertState = object.assertState ?? 0;
    message.operation = object.operation ?? 0;
    message.device = object.device ?? "";
    message.portName = object.portName ?? "";
    message.portId = object.portId ?? "";
    message.nodeId = object.nodeId ?? "";
    message.remoteNodeId = object.remoteNodeId ?? "";
    message.remoteDevice = object.remoteDevice ?? "";
    message.fabric = object.fabric ?? "";
    message.username = object.username ?? "";
    message.txnId = object.txnId ?? "";
    message.category = object.category ?? 0;
    message.objectType = object.objectType ?? 0;
    message.objectId = object.objectId ?? "";
    message.objectName = object.objectName ?? "";
    return message;
  },
};

function createBaseAssertionHistoryQueryResponse(): AssertionHistoryQueryResponse {
  return { rows: [], pagination: undefined };
}

export const AssertionHistoryQueryResponse: MessageFns<AssertionHistoryQueryResponse> = {
  encode(message: AssertionHistoryQueryResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.rows) {
      AssertionHistoryQueryRow.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.pagination !== undefined) {
      PaginationResponse.encode(message.pagination, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertionHistoryQueryResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertionHistoryQueryResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.rows.push(AssertionHistoryQueryRow.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pagination = PaginationResponse.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertionHistoryQueryResponse {
    return {
      rows: globalThis.Array.isArray(object?.rows)
        ? object.rows.map((e: any) => AssertionHistoryQueryRow.fromJSON(e))
        : [],
      pagination: isSet(object.pagination) ? PaginationResponse.fromJSON(object.pagination) : undefined,
    };
  },

  toJSON(message: AssertionHistoryQueryResponse): unknown {
    const obj: any = {};
    if (message.rows?.length) {
      obj.rows = message.rows.map((e) => AssertionHistoryQueryRow.toJSON(e));
    }
    if (message.pagination !== undefined) {
      obj.pagination = PaginationResponse.toJSON(message.pagination);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertionHistoryQueryResponse>, I>>(base?: I): AssertionHistoryQueryResponse {
    return AssertionHistoryQueryResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertionHistoryQueryResponse>, I>>(
    object: I,
  ): AssertionHistoryQueryResponse {
    const message = createBaseAssertionHistoryQueryResponse();
    message.rows = object.rows?.map((e) => AssertionHistoryQueryRow.fromPartial(e)) || [];
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationResponse.fromPartial(object.pagination)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000).toString();
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (globalThis.Number(t.seconds) || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
